import { useEffect, useState, useRef } from 'react';

interface UseAnimationOnScrollProps {
  threshold?: number;
  rootMargin?: string;
}

export const useAnimationOnScroll = ({ threshold = 0.1, rootMargin = '0px' }: UseAnimationOnScrollProps = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Once the animation has played, we can disconnect the observer
          if (elementRef.current) {
            observer.unobserve(elementRef.current);
          }
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    const currentElement = elementRef.current;
    
    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [threshold, rootMargin]);

  return { elementRef, isVisible };
};

export default useAnimationOnScroll;
